import React from 'react';
import {
	LabelContainer,
	StyledLabel,
} from '../../../../../common/ui/picker-trigger/trigger-component-no-operator/main.tsx';

export const TriggerLabelContainer = ({
	fieldLabel,
	parentValue,
	childValue,
}: {
	fieldLabel: string;
	parentValue?: string;
	childValue?: string;
}) => {
	const parentDisplay = parentValue ? `${parentValue}` : '';
	const childDisplay = parentValue && childValue ? ` - ${childValue}` : '';

	const displayValue = `${parentDisplay}${childDisplay}`;

	return (
		<LabelContainer data-testid="jql-builder-basic.ui.jql-editor.field.cascade-select-picker.trigger-label-container.label-container">
			{!parentValue && !childValue ? (
				fieldLabel
			) : (
				<>
					<StyledLabel>{fieldLabel}: </StyledLabel>
					{displayValue}
				</>
			)}
		</LabelContainer>
	);
};
